import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-649d2f2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: "article__content position-relative",
  style: {"margin-bottom":"2rem !important"}
}
const _hoisted_3 = {
  key: 0,
  class: "article__content article__content--hor"
}
const _hoisted_4 = { class: "article--text-block" }
const _hoisted_5 = { class: "article__text article__text--semibold" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = {
  class: "article__text article__text--semibold",
  ref: "productsTypes"
}
const _hoisted_9 = ["onMousemove"]
const _hoisted_10 = {
  key: 0,
  class: "article__text article__text--italic"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "structure-footnote" }, "*", -1))
const _hoisted_12 = { class: "position-relative" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "article__part-title" }, "Структура", -1))
const _hoisted_14 = {
  class: "chart-legend",
  style: {"bottom":"-2.8125rem"}
}
const _hoisted_15 = {
  ref: "chartNumber",
  "data-name": "chart-number"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_chart_pie = _resolveComponent("chart-pie")!
  const _component_not_found_block = _resolveComponent("not-found-block")!
  const _component_all_production_modal = _resolveComponent("all-production-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.data.childs.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("p", _hoisted_5, [
                      _createTextVNode(_toDisplayString(_ctx.range) + " " + _toDisplayString(_ctx.actionInRus) + " " + _toDisplayString(_ctx.productTypeInRus) + " в ЕГАИС зафиксировало " + _toDisplayString(_ctx.data.organizationCount) + " организаций. ", 1),
                      _hoisted_6,
                      _createTextVNode(" Объем " + _toDisplayString(_ctx.action3nd) + " составил " + _toDisplayString(_ctx.normalizeCommonVolume) + " тыс. дал. ", 1),
                      _hoisted_7
                    ]),
                    _createElementVNode("p", _hoisted_8, [
                      _createTextVNode(" В структуре " + _toDisplayString(_ctx.action3nd) + ": ", 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSortedProductList, (item, i) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: item.name,
                          class: _normalizeClass(["product", {'product--selected': item.name === _ctx.selected}]),
                          onMousemove: ($event: any) => (_ctx.selected = item.name),
                          onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selected = '')),
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openProductionModal && _ctx.openProductionModal(...args)))
                        }, [
                          _createElementVNode("span", {
                            class: "highlight",
                            style: _normalizeStyle(`color: ${item.color};`)
                          }, _toDisplayString(item.name), 5),
                          _createTextVNode(" (" + _toDisplayString(item.percent) + "%)" + _toDisplayString(_ctx.getSortedProductList?.length !== i + 1 ? ', ' : ''), 1)
                        ], 42, _hoisted_9))
                      }), 128)),
                      _createVNode(_component_el_button, {
                        text: "",
                        onClick: _ctx.openProductionModal,
                        class: "structure-expand structure-expand--relative material-icons-round"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" apps ")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ], 512),
                    (_ctx.data.endStageSd || _ctx.data.endStageSd === 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                          (_ctx.typeOfProduct === _ctx.ProductType.DISTILLATES && _ctx.type === _ctx.ActionName.PRODUCTION)
                            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                key: 0,
                                content: `Указан процент от объёма всей ${_ctx.action2nd} в регионе продукции`,
                                placement: "top"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_11,
                                  _createTextVNode(": ")
                                ]),
                                _: 1
                              }, 8, ["content"]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" Комментарий: объем " + _toDisplayString(_ctx.action3nd) + " этилового спирта без учета спиртов являющихся сырьем для " + _toDisplayString(_ctx.action3nd) + " других спиртов (таких как, денатурированный спирт, фармсубстанция) составил ", 1),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.getLocaleString(_ctx.data.endStageSd / 1000)), 1),
                          _createTextVNode(" тыс. дал. ")
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    (_ctx.getSortedProductList?.length)
                      ? (_openBlock(), _createBlock(_component_chart_pie, {
                          key: 0,
                          "instant-init": _ctx.instantInit,
                          onMousein: _ctx.handleIn,
                          onMouseout: _ctx.handleOut,
                          products: _ctx.getSortedProductList,
                          selected: _ctx.selected,
                          range: _ctx.range,
                          action3nd: _ctx.action3nd
                        }, null, 8, ["instant-init", "onMousein", "onMouseout", "products", "selected", "range", "action3nd"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_14, [
                      _createTextVNode(" Диаграмма №"),
                      _createElementVNode("span", _hoisted_15, "0", 512),
                      _createTextVNode(". "),
                      _hoisted_16,
                      _createTextVNode(" Структура " + _toDisplayString(_ctx.action2nd) + " продукции ", 1)
                    ]),
                    _createVNode(_component_el_button, {
                      text: "",
                      onClick: _ctx.openProductionModal,
                      class: "structure-expand material-icons-round"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" apps ")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]))
              : (_openBlock(), _createBlock(_component_not_found_block, {
                  key: 1,
                  text: "Данные не найдены"
                }))
          ]),
          _createVNode(_component_all_production_modal, {
            data: _ctx.getSortedProductList,
            "model-value": _ctx.productionModal,
            "activity-type": _ctx.type,
            "type-of-product": _ctx.typeOfProduct,
            target: _ctx.target,
            range: _ctx.range,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.productionModal = false))
          }, null, 8, ["data", "model-value", "activity-type", "type-of-product", "target", "range"])
        ]))
      : (_openBlock(), _createBlock(_component_not_found_block, {
          key: 1,
          text: "Данные не найдены"
        }))
  ]))
}